import {memo} from "react";
import {Chip} from "@material-tailwind/react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {solid} from "@fortawesome/fontawesome-svg-core/import.macro";
import {useTranslation} from "react-i18next";

export interface FilterChipDefinition {
    key: string;
    label: string;
    onRemove: () => void;
}

interface FilterChipsProps {
    items: FilterChipDefinition[];
    className?: string;
}

const FilterChips = ({items, className = ''}: FilterChipsProps) => {
    const {t} = useTranslation();

    if (!items.length) {
        return null;
    }

    return (
        <div className={className}>
            <div className="flex flex-nowrap gap-2 overflow-x-auto pb-2">
                {items.map((chip) => (
                    <Chip
                        key={chip.key}
                        className="bg-blue-gray-50 text-blue-gray-900 dark:bg-gray-800 dark:text-gray-200 rounded-full w-fit whitespace-nowrap px-3 py-1"
                        value={
                            <span className="flex items-center gap-2">
                            <span>{chip.label}</span>
                            <button
                                type="button"
                                aria-label={t('admin.reporting.deposits.reset')}
                                className="text-blue-gray-500 hover:text-teal-500 dark:text-gray-300 dark:hover:text-white"
                                onClick={(event) => {
                                    event.stopPropagation();
                                    chip.onRemove();
                                }}
                            >
                                <FontAwesomeIcon icon={solid('xmark')} className="w-3 h-3"/>
                            </button>
                        </span>
                        }
                    />
                ))}
            </div>
        </div>
    );
}

export default memo(FilterChips);
